import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';
import { Button } from 'ui-components/components/button';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';
import { useOnImportFinished } from '../../../../../components/csv-import/data/hooks/use-on-import-finished';
import { ImportStatus } from '../../../../../components/csv-import/data/types/import-status';
import { ImportType } from '../../../../../components/csv-import/data/types/import-type';
import { useModal } from '../../../../../hooks/use-modal';
import Global from '../../../../../store/global-selectors';
import { Workflows } from '../../../../../tracking/tracking-constants';
import { useTrackWorkflow, WorkflowSteps } from '../../../../../tracking/use-workflow-tracking';
import { PurchaseOrderImportDrawer } from '../../modals/purchase-order-import-drawer/purchase-order-import-drawer';
import style from '../action-button.module.less';
import { messages } from './messages';

type ImportButtonProps = {
  refreshPurchaseOrders: () => void;
  disabled: boolean;
};

export const ImportButton = ({ refreshPurchaseOrders, disabled }: ImportButtonProps) => {
  const { open: openImportDrawer, close: closeImportDrawer, isOpen: isImportDrawerOpen } = useModal();

  const trackImportProcess = useTrackWorkflow(Workflows.CSV_PURCHASE_ORDER_IMPORT_FLOW);

  const latestPurchaseOrderImport = useSelector((state) => Global.selectCsvImportType(state, ImportType.purchaseOrder));

  const openImportModal = () => {
    if (latestPurchaseOrderImport.status !== ImportStatus.ACTIVE) {
      trackImportProcess(WorkflowSteps.START, { version: 2 });
    }
    openImportDrawer();
  };

  useOnImportFinished(
    ImportType.purchaseOrder,
    useCallback(() => {
      if (isImportDrawerOpen) {
        refreshPurchaseOrders();
      }
    }, [isImportDrawerOpen, refreshPurchaseOrders]),
  );

  return (
    <>
      <Button className={style['reusable-button']} disabled={disabled} onClick={openImportModal} theme={THEME_CONSTANTS.tertiary}>
        <FormattedMessage {...messages.importButton} />
      </Button>

      {isImportDrawerOpen ? <PurchaseOrderImportDrawer onClose={closeImportDrawer} trackProcess={trackImportProcess} /> : null}
    </>
  );
};
